import { render, staticRenderFns } from "./goods-on-shelves.vue?vue&type=template&id=bfe5aea6&"
import script from "./goods-on-shelves.vue?vue&type=script&setup=true&lang=js&"
export * from "./goods-on-shelves.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./goods-on-shelves.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports